export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function getOtherBodyInPair(pair, body) {
  if (!pair || !body) return null;
  if (pair.bodyA && pair.bodyA.id === body.id) return pair.bodyB || null;
  if (pair.bodyB && pair.bodyB.id === body.id) return pair.bodyA || null;
  return null;
}

export function getBodyHalfHeight(body) {
  if (!body || !body.bounds) return 0;
  return Math.max(0, (body.bounds.max.y - body.bounds.min.y) / 2);
}

/** Lowest world-space Y on the body (handles rotated ellipse vertices). */
export function getFlaskBodyTopY(meta) {
  var body = meta && meta.body;
  if (!body) return 0;
  var top = Infinity;
  if (body.vertices && body.vertices.length) {
    for (var i = 0; i < body.vertices.length; i++) {
      var vy = body.vertices[i].y;
      if (vy < top) top = vy;
    }
  }
  if (isFinite(top)) return top;
  if (body.bounds && isFinite(body.bounds.min.y)) return body.bounds.min.y;
  var y = body.position.y;
  var radius = Math.max(meta.radiusX || 0, meta.radiusY || 0, 4);
  return y - radius;
}

/** Top/bottom Y — prefers live Matter bounds (critical for small tilted ellipses). */
export function getFlaskBodyVerticalExtents(meta) {
  var body = meta && meta.body;
  if (!body || !body.position) return { bodyTop: 0, bodyBottom: 0, halfH: 0 };
  var y = body.position.y;
  var top;
  var bottom;
  if (body.bounds
    && isFinite(body.bounds.min.y)
    && isFinite(body.bounds.max.y)
    && body.bounds.max.y > body.bounds.min.y) {
    top = body.bounds.min.y;
    bottom = body.bounds.max.y;
  } else {
    var halfH = getBodyHalfHeight(body);
    var radius = Math.max(meta.radiusX || 0, meta.radiusY || 0, 4);
    if (halfH < radius) halfH = radius;
    top = y - halfH;
    bottom = y + halfH;
  }
  var vertexTop = getFlaskBodyTopY(meta);
  if (vertexTop < top) top = vertexTop;
  return {
    bodyTop: top,
    bodyBottom: bottom,
    halfH: Math.max((bottom - top) / 2, 1),
  };
}
